// linkHolders — who holds a live link to a project but is not on its team
// (v0.300.0).
//
// Brett, on the "7 comments not sent yet — for 4 people" banner, where four of
// the seven were for test links made to someone never on the team: "If you are
// counting that then you need to add to the in the team section so we know to
// remove, otherwise there is no way of easily knowing".
//
// `links` is GET /api/report-shares?projectId= as read (live links only: not
// turned off, not expired). A system link (made for another app, e.g. InSpec)
// belongs to no person and is never listed. A link with no address is one
// group of its own ('Anyone with the link'), because it is the same question:
// who is reading this, and should they be?
//
// A person is "on the team" when their address matches a team member's,
// ignoring case and spaces either side — the same match the server uses.

export const normEmail = (e) => String(e || '').trim().toLowerCase();

export function strayLinkHolders(links, team) {
  const onTeam = new Set((Array.isArray(team) ? team : []).map((m) => normEmail(m.email)).filter(Boolean));
  const groups = new Map();
  for (const l of Array.isArray(links) ? links : []) {
    if (!l || l.kind === 'system' || l.revokedAt) continue;
    const key = normEmail(l.recipientEmail);
    if (key && onTeam.has(key)) continue;
    let g = groups.get(key);
    if (!g) {
      g = { key, email: key ? String(l.recipientEmail).trim() : '', links: [], permissions: [], lastUsedAt: null, firstMadeAt: null };
      groups.set(key, g);
    }
    g.links.push(l);
    if (l.permission && !g.permissions.includes(l.permission)) g.permissions.push(l.permission);
    if (l.lastUsedAt && (!g.lastUsedAt || new Date(l.lastUsedAt) > new Date(g.lastUsedAt))) g.lastUsedAt = l.lastUsedAt;
    if (l.createdAt && (!g.firstMadeAt || new Date(l.createdAt) < new Date(g.firstMadeAt))) g.firstMadeAt = l.createdAt;
  }
  // People by address; the no-address group last.
  return [...groups.values()].sort((a, b) => (!a.key) - (!b.key) || a.key.localeCompare(b.key));
}
